import {Assertion} from '@udemy/badging';

function parseYearMonth(dateStr?: string): {year: number; month: number} | undefined {
    if (!dateStr) {
        return undefined;
    }
    const date = new Date(dateStr);
    if (isNaN(date.getTime())) {
        return undefined;
    }
    return {year: date.getUTCFullYear(), month: date.getUTCMonth() + 1};
}

export function buildAddToLinkedInUrl(assertion: Assertion): string {
    const params = new URLSearchParams({
        startTask: 'CERTIFICATION_NAME',
        name: assertion.badgeClass.name,
        organizationName: assertion.badgeClass.issuer.name,
        certId: assertion.id,
    });

    const issuedOn = parseYearMonth(assertion.issuedOn);
    if (issuedOn) {
        params.set('issueYear', String(issuedOn.year));
        params.set('issueMonth', String(issuedOn.month));
    }

    const expires = parseYearMonth(assertion.expires);
    if (expires) {
        params.set('expirationYear', String(expires.year));
        params.set('expirationMonth', String(expires.month));
    }

    return `https://www.linkedin.com/profile/add?${params.toString()}`;
}
